import React, { Component, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import {LanguageSwitcher, Loading, GelContentContainer, NotFound, withRouter} from 'cw-styleguide-react';
import Utility from "../utility";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { route, routeTranslated } from "../routes";
import Animal from '../components/Animal';
import i18n from '../i18n';
import GaHelmet from '../components/GaHelmet';

class DetailsView extends Component {
  render() {


    const code = this.props.animal.code;


    return (
      <Fragment>
        <GaHelmet>
          <title>{this.props.animal.name} | {this.props.t('route_app_title')}</title>
        </GaHelmet>
        <LanguageSwitcher to={routeTranslated('animal', { id: this.props.animals[code][i18n.language === 'en' ? 'cy' : 'en'], tab: this.props.t('results.tabs.personality.slug', { lng: i18n.language === 'en' ? 'cy' : 'en' }) })} />
        <BreadcrumbsItem to={route('animal', { id: this.props.animals[code][i18n.language], tab: this.props.t('results.tabs.personality.slug') })}>
          {this.props.animal.name}
        </BreadcrumbsItem>
        <GelContentContainer>

          <Animal animal={this.props.animal} resetAnswers={this.props.resetAnswers} baseRoute={route('animals') + '/' + this.props.animals[code][i18n.language]} />
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withRouter(withTranslation('local')(DetailsView));
